module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a oncontextmenu="return false" class="bill-link" href="#bills/'+
((__t=( document_type ))==null?'':_.escape(__t))+
'/'+
((__t=( number ))==null?'':_.escape(__t))+
'" title="'+
((__t=( caption ))==null?'':_.escape(__t))+
'"><i class="fa-regular fa-file-lines"></i>'+
((__t=( document_type ))==null?'':_.escape(__t))+
''+
((__t=( number ))==null?'':_.escape(__t))+
'</a>\n';
}
return __p;
};
